/** Minimum closing chance (0–100) to classify a deal as "hot". */
export const HOT_DEAL_PROBABILITY_MIN = 80;

/** A deal with no completed activity for this many months is considered inactive. */
export const INACTIVE_DEAL_MONTHS = 3;

/** Closing chance (0–100) below which the probability bar shows as at-risk (warning tone). */
export const LOW_PROBABILITY_MAX = 30;

/** Closing chance (0–100) below which the probability bar shows as uncertain (caution tone); above it, success. */
export const MEDIUM_PROBABILITY_MAX = 60;
